module.exports = __webpack_public_path__ + "img/saudi-arabia.ec70a487.svg";